export default function Catalogos() {
  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Catálogos</strong> — Datos compartidos entre todos los tenants</div>
      </div>
      <div className="content">
        <div className="info-banner">
          Los catálogos son globales y compartidos por todos los tenants del sistema. Cambios aquí afectan a todos.
        </div>
        <div className="panel">
          <div className="panel-head">Módulo en construcción</div>
          <div className="panel-body empty">
            Próximamente: actividades económicas, giros, formas de pago, unidades de medida, departamentos y municipios.
          </div>
        </div>
      </div>
    </>
  )
}
